<template>
    <div id="pinger-edit">
        <div id="page-head">
            <ul id="breadcrumbs">
                <li><router-link :to="{ name: 'Dashboard' }">Dashboard</router-link></li>
                <li><router-link :to="{ name: 'PingerIndex' }">Site Pinger</router-link></li>
                <li>Edit Domain</li>
            </ul>
        </div>

        <loading v-if="loading"></loading>
        <div v-else class="panel">
            <div class="panel-head">
                <h2>Edit Domain</h2>
                <!--
                <ul class="actions">
                    <li><a @click.prevent="destroy()" class="action" href="#">Delete</a></li>
                </ul>
                -->
            </div>
            <div class="panel-body">
                <form>
                    <div class="form-control">
                        <label for="client">Client</label>
                        <select v-model="pinger.client_id">
                            <option :value="null">--</option>
                            <option v-for="client in clients" :value="client.id">{{ client.name }}</option>
                        </select>
                    </div>

                    <div class="form-control-group">
                        <div class="form-control">
                            <label for="protocol">Protocol</label>
                            <select>
                                <option>https://</option>
                                <option>http://</option>
                            </select>
                        </div>

                        <div class="form-control grow-3x">
                            <label for="domain">Domain</label>
                            <input v-model="pinger.domain" type="text" placeholder="example.com">
                        </div>
                    </div>

                    <div class="form-control">
                        <label for="interval">Ping Interval</label>
                        <select v-model="pinger.interval">
                            <option value="1">Every Hour</option>
                            <option value="6">Every 6 Hours</option>
                            <option value="12">Every 12 Hours</option>
                            <option value="24">Every 24 Hours</option>
                            <option value="-1">Disabled</option>
                        </select>
                    </div>
                    <button @click.prevent="save()" class="button button-green">Update</button>
                    <button @click.prevent="ping()" class="button button-blue">Ping Now</button>
                </form>
            </div>
        </div>

        <div v-if="!loading">
            <page-index :root="pinger.protocol + pinger.domain"></page-index>
        </div>
    </div>
</template>

<script>
import PageIndex from '@/components/pinger/pages/PageIndex'
import Loading from '@/components/ui/Loading'

export default {
    name: 'PingerEdit',
    components: {
        PageIndex,
        Loading
    },
    data() {
        return {
            loading: true,
            pinger: {},
            pages: [],
            clients: []
        }
    },
    async created() {
        await this.loadClients()
        await this.loadPinger()

        this.loading = false
    },
    methods: {
        async loadClients() {
            let response = await this.$http.get('/clients')
            this.clients = response.data
        },
        async loadPinger() {
            let response = await this.$http.get('/pingers/' + this.$route.params.id)
            this.pinger = response.data
        },
        async save() {
            let response = await this.$http.put('/pingers/' + this.$route.params.id, this.pinger)
            this.$router.replace({ name: 'PingerIndex' })
        },
        async ping() {
            this.loading = true
            let response = await this.$http.get('/pingers/' + this.$route.params.id + '/ping')
            this.$router.replace({ name: 'PingerEdit', params: { id: this.$route.params.id} })
            this.loading = false
        },
        async destroy() {
            if(window.confirm('Are you sure you want to delete this domain?')) {
                let response = await this.$http.delete('/pingers/' + this.$route.params.id)
                this.$router.replace({ name: 'PingerIndex' })
            }
        }
    }
}
</script>

<style lang="scss">
#pinger-edit {
    .title {
        margin-top: 30px;
        font-size: 18px;
    }

    .no-pages {
        margin-bottom: 15px;
    }

    .add-page {
        margin-top: 0;
    }
}
</style>
